<template>
  <div v-if="loading">
    <loader-static class="flex align-center justify-center min-height-300" />
  </div>
  <div v-else>
    <checkbox-new
      v-for="(brand, index) in getFilteredItems(brands, 'name', selectedBrand)"
      :key="index"
      v-model="brand.selected"
      :label="brand.name"
      @click="select(brand)"
    ></checkbox-new>
  </div>
</template>

<script>
import { paramsHelper } from "@/components/mixin/paramsHelper";
import { filterHelper } from "./filterHelper";
import { FilterKeys } from "../../../../services/utils";

export default {
  mixins: [paramsHelper, filterHelper],
  data() {
    return {
      loading: true,
      brands: [],
      selectedBrand: null,
    };
  },
  watch: {
    "$route.query.brands": function () {
      this.parseSelectedValues();
      this.transformListEmitFilterSelection();
    },
  },
  async beforeMount() {
    await this.getBrands();
    this.parseSelectedValues();
    this.transformListEmitFilterSelection();
  },
  methods: {
    select,
    getBrands,
    clearSearch,
    setSelectedBrand,
    transformListEmitFilterSelection,
    parseSelectedValues,
  },
};

function setSelectedBrand() {
  this.selectedBrand = this.brands.find((item) => item.id === this.$route.query.brand);
  this.selectedBrand.selected = true;
  if (this.selectedBrand) {
    this.setParentSearchValue(this.selectedBrand.name);
  }
  this.updateParentSelectionCount(this.brands);
}
function clearSearch() {
  this.updateURLParams("brand", false);
}

function select(brand) {
  brand.selected = !brand.selected;
  this.updateFilterURLParams(
    FilterKeys.BRANDS,
    this.brands?.filter((item) => item.selected).map((item) => item.id)
  );
  this.updateParentSelectionCount(this.brands);
  this.transformListEmitFilterSelection();
  this.$forceUpdate();
  this.trackFilterUsedEvent("brand");
}

function transformListEmitFilterSelection() {
  this.emitFilterSelection({
    filterKey: FilterKeys.BRANDS,
    items: this.brands.map(({ name, id, selected }) => {
      return { label: name, value: id, selected };
    }),
  });
}

function parseSelectedValues() {
  const selectedBrands = this.$utils.arrayify(this.$route.query.brands);
  this.brands.forEach((item) => (item.selected = false));
  this.brands.forEach((item) => {
    if (selectedBrands?.includes(item.id)) {
      item.selected = true;
    }
  });
  this.$forceUpdate();
}

async function getBrands() {
  this.loading = true;
  const { data } = await this.$utils.getAllBrands();
  this.brands = data.brands_dropdown;
  this.loading = false;
}
</script>
